import { Link } from "react-router-dom";
import { categories } from "@/mocks/manga";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-book-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">
                178<span className="text-primary-600">漫画网</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              提供免费漫画在线阅读服务，涵盖恋爱、校园、日常、治愈等多种题材。无需付费，即可享受完整章节与高清画面。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950">热门分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="inline-block text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {c.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-2">
              <li>
                <Link to="/" className="inline-block text-sm text-foreground-600 hover:text-primary-600">首页</Link>
              </li>
              <li>
                <Link to="/category/love" className="inline-block text-sm text-foreground-600 hover:text-primary-600">漫画分类</Link>
              </li>
              <li>
                <Link to="/category/daily" className="inline-block text-sm text-foreground-600 hover:text-primary-600">最新更新</Link>
              </li>
              <li>
                <Link to="/about" className="inline-block text-sm text-foreground-600 hover:text-primary-600">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>service@178manga.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-500"></i>客服在线时间 09:00-21:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-500"></i>公众号：178漫画网
              </li>
            </ul>
            <div className="mt-4 flex gap-3">
              <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"><i className="ri-weibo-line"></i></a>
              <a href="#" aria-label="抖音" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"><i className="ri-music-2-line"></i></a>
              <a href="#" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"><i className="ri-play-circle-line"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 md:px-6 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 178漫画网 · 满溢游泳池漫画免费在线阅读 · 本站内容仅供学习交流</p>
          <p>漫画免费阅读 · 漫画全集 · 高清画面</p>
        </div>
      </div>
    </footer>
  );
}